export default __webpack_public_path__ + "static/media/earth_texture_diffuse.375b84c8.jpg";